
// import { useState, useEffect, useRef } from "react";
// import { motion } from "framer-motion";
// import IndustriesSection from "./IndustiresSection";

// /* ── SVG ICONS ── */
// const IconMachine = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/>
//     <line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/>
//     <line x1="10" y1="6" x2="16" y2="6"/><line x1="10" y1="18" x2="16" y2="18"/>
//   </svg>
// );
// const IconERP = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
//     <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
//   </svg>
// );
// const IconApp = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>
//   </svg>
// );
// const IconPayroll = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
//     <line x1="6" y1="15" x2="10" y2="15"/><line x1="14" y1="15" x2="16" y2="15"/>
//   </svg>
// );
// const IconManufacturing = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M2 20h20"/><path d="M5 20V8l4-4 4 4v12"/>
//     <path d="M15 20v-6h4v6"/><path d="M9 20v-4h2v4"/>
//   </svg>
// );
// const IconMobile = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>
//   </svg>
// );
// const IconWeb = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
//     <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
//   </svg>
// );
// const IconHR = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
//     <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
//   </svg>
// );
// const IconHelpdesk = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
//     <line x1="9" y1="10" x2="15" y2="10"/><line x1="12" y1="7" x2="12" y2="13"/>
//   </svg>
// );
// const IconMaintenance = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
//   </svg>
// );
// const IconChatbot = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="3" width="18" height="14" rx="2"/><path d="M8 17v4l4-4"/>
//     <line x1="8" y1="9" x2="16" y2="9"/><line x1="8" y1="12" x2="13" y2="12"/>
//   </svg>
// );
// const IconFinance = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//     <line x1="12" y1="1" x2="12" y2="23"/>
//     <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
//   </svg>
// );

// const SERVICES = [
//   { icon: <IconMachine />,       title: "Machine Integration",             description: "Increase productivity and lower costs by managing your sales and purchase cycles, from purchase to sales orders. Improve collaboration between sales, purchasing, and warehousing for seamless order management." },
//   { icon: <IconERP />,           title: "ERP Services",                    description: "Our custom application and consulting services are designed to meet the unique needs of your business. Optimize operations, streamline processes, and achieve unprecedented success with our expertise." },
//   { icon: <IconApp />,           title: "Custom Application & Consulting", description: "At GalaxyERP Software Private Limited, we understand that your business is unique. Our team will work closely with you to design and develop a bespoke ERP system that meets your specific needs." },
//   { icon: <IconPayroll />,       title: "Pay Roll",                        description: "Automate payroll processes seamlessly with our ERP software, ensuring accurate salary calculations, compliance, and streamlined payroll management for your entire business." },
//   { icon: <IconManufacturing />, title: "Manufacturing",                   description: "Effectively maintain and manage multilevel bill of materials, production planning, job cards & inventory. End-to-end visibility into your entire manufacturing floor." },
//   { icon: <IconMobile />,        title: "Mobile Applications",             description: "Enhance your business operations with mobile applications that allow you to manage your sales cycle, inventory, and other essential tasks from anywhere, anytime." },
//   { icon: <IconWeb />,           title: "Web Applications",                description: "Streamline your business processes with web applications that provide a user-friendly interface for managing your inventory, sales, and other essential tasks." },
//   { icon: <IconHR />,            title: "HR",                              description: "Manage full employee life cycle right from onboarding, payroll, attendance, expense claims, assets to separation. One unified system for your entire workforce." },
//   { icon: <IconHelpdesk />,      title: "Helpdesk",                        description: "Deliver a better service experience with an intuitive issue tracker and an integrated knowledge base. Resolve customer issues faster with smart automation." },
//   { icon: <IconMaintenance />,   title: "Maintenance Support Services",    description: "Ensure the smooth operation of your ERP system with maintenance support services including regular updates, bug fixes, and performance enhancements." },
//   { icon: <IconChatbot />,       title: "Chatbot Services",                description: "Improve customer service and communication with chatbot services that assist customers, answer questions, and provide real-time information 24/7." },
//   { icon: <IconFinance />,       title: "Financial Accounting",            description: "Get a real-time view of your cash flow. Full-fledged accounting module covering every aspect of bookkeeping, from ledger to balance sheet." },
// ];

// const Services = () => {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const itemRefs = useRef([]);

//   useEffect(() => {
//     const observers = [];
//     itemRefs.current.forEach((el, i) => {
//       if (!el) return;
//       const obs = new IntersectionObserver(
//         ([entry]) => {
//           if (entry.isIntersecting) setActiveIndex(i);
//         },
//         {
//           // Trigger when item is in middle 30% of screen
//           rootMargin: "-40% 0px -40% 0px",
//           threshold: 0,
//         }
//       );
//       obs.observe(el);
//       observers.push(obs);
//     });
//     return () => observers.forEach((o) => o.disconnect());
//   }, []);

//   const scrollTo = (i) =>
//     itemRefs.current[i]?.scrollIntoView({ behavior: "smooth", block: "center" });

//   return (
//     <>
//     <motion.div
//       className="svc-wrap"
//       id="service"
//       initial={{ opacity: 0 }}
//       whileInView={{ opacity: 1 }}
//       transition={{ duration: 0.5 }}
//       viewport={{ once: true }}
//     >
//       {/* Header */}
//       <div className="svc-header">
//         <p className="svc-overline">Streamlines Your Business</p>
//         <h2 className="svc-main-title">Our Services</h2>
//       </div>

//       {/* Body — grid: left sticky | right scrollable */}
//       <div className="svc-body">

//         {/* LEFT — sticky, all 12 titles */}
//         <div className="svc-sticky">
//           <p className="svc-sticky-label">what we offer</p>
//           <ul className="svc-nav">
//             {SERVICES.map((s, i) => (
//               <li
//                 key={i}
//                 className={`svc-nav-item${activeIndex === i ? " is-active" : ""}`}
//                 onClick={() => scrollTo(i)}
//               >
//                 {s.title}
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* RIGHT — each entry is 100vh so user must scroll through all 12 */}
//         <div className="svc-feed">
//           {SERVICES.map((s, i) => (
//             <div
//               key={i}
//               ref={(el) => (itemRefs.current[i] = el)}
//               className={`svc-entry${activeIndex === i ? " is-active" : ""}`}
//             >
//               <div className="svc-content">
//                 <div className="svc-content-icon">{s.icon}</div>
//                 <h3 className="svc-content-title">{s.title}</h3>
//                 <p className="svc-content-desc">{s.description}</p>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </motion.div>
//     <IndustriesSection/>
//     </>
//   );
// };

// export default Services;




import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import IndustriesSection from "./IndustiresSection";

/* ── SVG ICONS ── */
const IconMachine = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/><line x1="10" y1="6" x2="16" y2="6"/><line x1="10" y1="18" x2="16" y2="18"/></svg>);
const IconERP = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>);
const IconApp = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>);
const IconPayroll = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/><line x1="6" y1="15" x2="10" y2="15"/><line x1="14" y1="15" x2="16" y2="15"/></svg>);
const IconManufacturing = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 20h20"/><path d="M5 20V8l4-4 4 4v12"/><path d="M15 20v-6h4v6"/><path d="M9 20v-4h2v4"/></svg>);
const IconMobileIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>);
const IconWeb = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>);
const IconHR = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>);
const IconHelpdesk = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><line x1="9" y1="10" x2="15" y2="10"/><line x1="12" y1="7" x2="12" y2="13"/></svg>);
const IconMaintenance = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>);
const IconChatbot = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="14" rx="2"/><path d="M8 17v4l4-4"/><line x1="8" y1="9" x2="16" y2="9"/><line x1="8" y1="12" x2="13" y2="12"/></svg>);
const IconFinance = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>);

const SERVICES = [
  { icon: <IconMachine />,       title: "Machine Integration",     description: "Increase productivity and lower costs by managing your sales and purchase cycles. Improve collaboration between sales, purchasing, and warehousing for seamless order management.",  image:"/assets/img/Service/machine.jpg" },
  { icon: <IconERP />,           title: "ERP Services",            description: "Our custom application and consulting services are designed to meet the unique needs of your business. Optimize operations, streamline processes, and achieve unprecedented success.",   image: "/assets/img/Service/erp.jpg" },
  { icon: <IconApp />,           title: "Custom App & Consulting", description: "We understand that your business is unique. Our team will work closely with you to design and develop a bespoke ERP system that meets your specific needs.",                        image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&q=80" },
  { icon: <IconPayroll />,       title: "Pay Roll",                description: "Automate payroll processes seamlessly with our ERP software, ensuring accurate salary calculations, compliance, and streamlined payroll management.",                                      image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&q=80" },
  { icon: <IconManufacturing />, title: "Manufacturing",           description: "Effectively maintain multilevel bill of materials, production planning, job cards & inventory. End-to-end visibility into your entire manufacturing floor.",                               image:  "/assets/img/Service/manufactre.jpg" },
  { icon: <IconMobileIcon />,    title: "Mobile Applications",     description: "Enhance operations with mobile apps that let you manage your sales cycle, inventory, and other essential tasks from anywhere, anytime.",                                                     image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80" },
  { icon: <IconWeb />,           title: "Web Applications",        description: "Streamline your business processes with web applications providing a user-friendly interface for managing inventory, sales, and other essential tasks.",                                     image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&q=80" },
  { icon: <IconHR />,            title: "HR",                      description: "Manage full employee life cycle — onboarding, payroll, attendance, expense claims, assets to separation. One unified system for your entire workforce.",                                    image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&q=80" },
  { icon: <IconHelpdesk />,      title: "Helpdesk",                description: "Deliver a better service experience with an intuitive issue tracker and integrated knowledge base. Resolve customer issues faster with smart automation.",                                  image: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=800&q=80" },
  { icon: <IconMaintenance />,   title: "Maintenance Support",     description: "Ensure smooth ERP operation with maintenance support including regular updates, bug fixes, and performance enhancements.",                                                                   image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80"  },
  { icon: <IconChatbot />,       title: "Chatbot Services",        description: "Improve customer service with chatbot services that assist customers, answer questions, and provide real-time information 24/7.",                                                        image: "/assets/img/Service/chatbot.avif" },
  { icon: <IconFinance />,       title: "Financial Accounting",    description: "Get a real-time view of your cash flow. Full-fledged accounting module covering every aspect of bookkeeping, from ledger to balance sheet.",                                                image:  "/assets/img/Service/finance.avif"},
];

const MOBILE_BREAKPOINT = 1024;

const Services = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT
  );
  const [direction, setDirection] = useState(1);
  const itemRefs = useRef([]);
  const tabsRef = useRef(null);
  const touchStartX = useRef(null);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (isMobile) return;
    const observers = [];
    itemRefs.current.forEach((el, i) => {
      if (!el) return;
      const obs = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) setActiveIndex(i); },
        { rootMargin: "-40% 0px -40% 0px", threshold: 0 }
      );
      obs.observe(el);
      observers.push(obs);
    });
    return () => observers.forEach((o) => o.disconnect());
  }, [isMobile]);

  useEffect(() => {
    if (!isMobile || !tabsRef.current) return;
    const el = tabsRef.current.children[activeIndex];
    el?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }, [activeIndex, isMobile]);

  const changeIndex = (i, dir) => { setDirection(dir); setActiveIndex(i); };

  const handleNavClick = (i) => {
    if (isMobile) changeIndex(i, i > activeIndex ? 1 : -1);
    else itemRefs.current[i]?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    if (!touchStartX.current) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0 && activeIndex < SERVICES.length - 1) changeIndex(activeIndex + 1, 1);
      else if (diff < 0 && activeIndex > 0) changeIndex(activeIndex - 1, -1);
    }
    touchStartX.current = null;
  };

  const variants = {
    enter:  (d) => ({ opacity: 0, x: d > 0 ? 40 : -40 }),
    center: { opacity: 1, x: 0 },
    exit:   (d) => ({ opacity: 0, x: d > 0 ? -40 : 40 }),
  };

  return (
    <>
      <motion.div className="svc-wrap" id="service"
        initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5 }} viewport={{ once: true }}
      >
        <div className="svc-header">
          <p className="svc-overline">Streamlines Your Business</p>
          <h2 className="svc-main-title">Our Services</h2>
        </div>

        {isMobile ? (
          <div className="svc-mobile">

            {/* ── Horizontal scrollable tab bar (original) ── */}
            <div className="svc-tabs" ref={tabsRef}>
              {SERVICES.map((s, i) => (
                <button
                  key={i}
                  className={`svc-tab${activeIndex === i ? " is-active" : ""}`}
                  onClick={() => handleNavClick(i)}
                >
                  {s.title}
                </button>
              ))}
            </div>

            {/* ── Swipeable content panel (original structure + photo added) ── */}
            <div
              className="svc-panel-wrap"
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              <AnimatePresence mode="wait" custom={direction}>
                <motion.div
                  key={activeIndex}
                  className="svc-panel"
                  custom={direction}
                  variants={variants}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  transition={{ duration: 0.28, ease: [0.4, 0, 0.2, 1] }}
                >
                  {/* ── Photo at top of panel ── */}
                  <div className="svc-panel-image-wrap">
                    <img
                      src={SERVICES[activeIndex].image}
                      alt={SERVICES[activeIndex].title}
                      className="svc-panel-image"
                    />
                    <div className="svc-panel-image-overlay" />
                    {/* counter badge on image */}
                    <div className="svc-panel-tag">
                      {String(activeIndex + 1).padStart(2, "0")} of {String(SERVICES.length).padStart(2, "0")}
                    </div>
                  </div>

                  {/* ── Original text content below photo ── */}
                  <div className="svc-panel-body">
                    {/* Icon row */}
                    <div className="svc-panel-icon-row">
                      <div className="svc-panel-icon">
                        {SERVICES[activeIndex].icon}
                      </div>
                    </div>

                    {/* Title */}
                    <h3 className="svc-panel-title">
                      {SERVICES[activeIndex].title}
                    </h3>

                    {/* Blue accent bar */}
                    <div className="svc-panel-accent" />

                    {/* Description */}
                    <p className="svc-panel-desc">
                      {SERVICES[activeIndex].description}
                    </p>

                    {/* Dot indicators */}
                    <div className="svc-dots">
                      {SERVICES.map((_, i) => (
                        <span
                          key={i}
                          className={`svc-dot${activeIndex === i ? " is-active" : ""}`}
                          onClick={() => changeIndex(i, i > activeIndex ? 1 : -1)}
                        />
                      ))}
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>

        ) : (
          <div className="svc-body">
            <div className="svc-sticky">
              <p className="svc-sticky-label">what we offer</p>
              <ul className="svc-nav">
                {SERVICES.map((s, i) => (
                  <li key={i}
                    className={`svc-nav-item${activeIndex === i ? " is-active" : ""}`}
                    onClick={() => handleNavClick(i)}
                  >{s.title}</li>
                ))}
              </ul>
            </div>
            <div className="svc-feed">
              {SERVICES.map((s, i) => (
                <div key={i}
                  ref={(el) => (itemRefs.current[i] = el)}
                  className={`svc-entry${activeIndex === i ? " is-active" : ""}`}
                >
                  <div className="svc-content">
                    {/* Desktop image */}
                    <div className="svc-content-image-wrap">
                      <img src={s.image} alt={s.title} className="svc-content-image" />
                      <div className="svc-content-image-overlay" />
                    </div>
                    <div className="svc-content-icon">{s.icon}</div>
                    <h3 className="svc-content-title">{s.title}</h3>
                    <p className="svc-content-desc">{s.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </motion.div>
      <IndustriesSection />
    </>
  );
};

export default Services;